import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AdminRequestDto, AdminResponseDto, AdminService, DeliveryOutputDto, DeliveryPayingInputDto, DeliveryPayingService, DeliveryService, OrderService } from 'src/generated_client';

@Component({
  selector: 'app-liquidaciones-cadetes',
  templateUrl: './liquidaciones-cadetes.component.html',
  styleUrls: ['./liquidaciones-cadetes.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LiquidacionesCadetesComponent implements OnInit {

  displayedColumns: string[] = ['order', 'date', 'client', 'total', 'shipment', 'commission', 'liquidacion'];
  dataSource: any = [];
  allDeliveries: DeliveryOutputDto[] = [];
  dateFrom: any;
  dateTo: any;
  totalDelivery: number = 0;
  totalCommission: number = 0;
  totalLiq: number = 0;
  totalReceipts: number = 0;
  deliveryPayingInput: DeliveryPayingInputDto = {};
  observaciones: string = '';
  ordersList: number[] = [];
  neto: number = 0;
  password: string = '';
  currentUser: AdminResponseDto = {};

  cadetesForm: FormGroup = this.fb.group({
    cadete: ['', Validators.required],
    number: [''],
  })

  constructor(
    public deliveryService: DeliveryService,
    public deliveryPayingService: DeliveryPayingService,
    public orderService: OrderService,
    public adminService: AdminService,
    public authService: AuthService,
    private fb: FormBuilder,
    private snackBar: SnackBarService
  ) { }

  private toArray<T>(response: any): T[] {
    if (Array.isArray(response)) {
      return response;
    }

    const candidates = [response?.data, response?.items, response?.result, response?.values];
    const firstArray = candidates.find(Array.isArray);

    return firstArray ?? [];
  }

  ngOnInit() {
    this.deliveryService.apiDeliveryGetAllGet().subscribe(response => {
      this.allDeliveries = this.toArray<DeliveryOutputDto>(response);
    })
  }

  inpuDateFrom(event: any) {
    this.dateFrom = event.value;
  }

  inpuDateTo(event: any) {
    this.dateTo = event.value;
  }

  search(form: any) {
    this.ordersList = [];
    this.totalDelivery = 0;
    this.totalCommission = 0;
    this.totalLiq = 0;
    this.totalReceipts = 0;
    this.neto = 0;

    const dateTo = this.dateTo ? moment(this.dateTo).endOf('day').toDate() : undefined;
    this.orderService.apiOrderGetOrdersByDeliveryAndDateGet(form.cadete, this.dateFrom, dateTo).subscribe(response => {
      const orders = this.toArray<any>(response);
      this.dataSource = orders;
      this.totalReceipts = orders.length;
      orders.forEach(r => {
        this.totalDelivery = this.totalDelivery + r.qtDCharges!;
        this.totalCommission = this.totalCommission + r.qtComisionCadete!;
        this.totalLiq = this.totalLiq + (r.qtDCharges! - r.qtComisionCadete!);
        this.ordersList.push(r.cdOrder!);
        this.neto = this.neto + r.qtTotal!
      })
    })
  }

  confirm() {
    this.currentUser = this.authService.currentUser();
    let confirm: AdminRequestDto = {
      dsPassword: this.password,
      dsUsername: this.currentUser.dsUsername!
    }
    this.adminService.apiAdminConfirmPost(confirm).subscribe(response => {
      let today = moment().toDate();
      this.deliveryPayingInput = {
        cdDelivery: this.cadetesForm.get('cadete')!.value,
        dsObservation: this.observaciones,
        listCdOrder: this.ordersList,
        qtComission: this.totalCommission,
        dtFecha: today,
        qtNeto: this.neto,
        qtPaying: this.totalLiq,
        qtReceipt: this.totalReceipts,
        qtTotal: (this.neto + this.totalDelivery),
      }
      this.deliveryPayingService.apiDeliveryPayingPostLiquidationPost(this.deliveryPayingInput).subscribe(response => {
        this.snackBar.openSnackBar('Liquidación emitida con éxito.', 'Aceptar')
      }, error => {
        this.snackBar.openSnackBar(error.error.error, 'Aceptar')
      })
    }, error => {
      this.snackBar.openSnackBar('La contraseña es incorrecta.', 'Aceptar');
    })

  }

}